// All content sourced from The House of Meilleur — Corporate & Brand Portfolio 2026.
// This is mock/static data powering the frontend. Later replaceable by a backend.

export const IMAGES = {
  heroSmoke: "https://images.unsplash.com/photo-1512917860049-18d416baa831?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxpbmNlbnNlJTIwc21va2V8ZW58MHx8fHwxNzg3NzQ2MTI2fDA&ixlib=rb-4.1.0&q=85",
  incenseStick: "https://images.unsplash.com/photo-1541795083-1b160cf4f3d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxpbmNlbnNlJTIwc21va2V8ZW58MHx8fHwxNzg3NzQ2MTI2fDA&ixlib=rb-4.1.0&q=85",
  ritualSmoke: "https://images.pexels.com/photos/31097197/pexels-photo-31097197.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  blueSmoke: "https://images.unsplash.com/photo-1547070451-ce386c65160a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxzbW9rZSUyMGRhcmt8ZW58MHx8fGJsYWNrfDE3ODc3NDYxMzR8MA&ixlib=rb-4.1.0&q=85",
  whiteSmoke: "https://images.unsplash.com/photo-1536405416754-3bcd4fb38128?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxzbW9rZSUyMGRhcmt8ZW58MHx8fGJsYWNrfDE3ODc3NDYxMzR8MA&ixlib=rb-4.1.0&q=85",
  oudChips: "https://images.unsplash.com/photo-1736098687867-3ec9f69aff2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxvdWQlMjB3b29kfGVufDB8fHx8MTc4Nzc0NjE3Mnww&ixlib=rb-4.1.0&q=85",
  attarBottle: "https://images.unsplash.com/photo-1646149757906-e6e9e9a7c77f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxhdHRhciUyMGJvdHRsZXxlbnwwfHx8fDE3ODc3NDYxNzJ8MA&ixlib=rb-4.1.0&q=85",
  attarBottlesGold: "https://images.unsplash.com/photo-1669444699729-f55f7cf9f82b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxhdHRhciUyMGJvdHRsZXxlbnwwfHx8fDE3ODc3NDYxNzJ8MA&ixlib=rb-4.1.0&q=85",
  perfumeArabic: "https://images.pexels.com/photos/38721545/pexels-photo-38721545.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bakhoorBowl: "https://images.unsplash.com/photo-1599285062038-950c5e0b672a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxiYWtob29yJTIwaW5jZW5zZXxlbnwwfHx8fDE3ODc3NDYxNzJ8MA&ixlib=rb-4.1.0&q=85",
  incenseBrass: "https://images.unsplash.com/photo-1583182363039-59eac8609ab2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxiYWtob29yJTIwaW5jZW5zZXxlbnwwfHx8fDE3ODc3NDYxNzJ8MA&ixlib=rb-4.1.0&q=85",
  perfumeGold: "https://images.unsplash.com/photo-1622618991746-fe6004db3a47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBwZXJmdW1lJTIwYm90dGxlJTIwZ29sZHxlbnwwfHx8fDE3ODc3NDYyMDN8MA&ixlib=rb-4.1.0&q=85",
  perfumeGold2: "https://images.pexels.com/photos/37127787/pexels-photo-37127787.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  forest: "https://images.unsplash.com/photo-1583470790878-4f4f3811a01f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHx0cm9waWNhbCUyMGZvcmVzdCUyMHRyZWVzfGVufDB8fHx8MTc4Nzc0NjIyMHww&ixlib=rb-4.1.0&q=85",
  forest2: "https://images.pexels.com/photos/5769574/pexels-photo-5769574.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  carvedArt: "https://images.pexels.com/photos/36492217/pexels-photo-36492217.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  jewellery: "https://images.pexels.com/photos/11332062/pexels-photo-11332062.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  chipMacro1: "https://images.pexels.com/photos/9035374/pexels-photo-9035374.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  chipMacro2: "https://images.unsplash.com/photo-1621295693450-080546d2ec8e?crop=entropy&cs=srgb&fm=jpg&q=90&w=1400",
  chipMacro3: "https://images.unsplash.com/photo-1697507695420-04623ccff2af?crop=entropy&cs=srgb&fm=jpg&q=90&w=1400",
  chipMacro4: "https://images.unsplash.com/photo-1583418007992-a8e33a92e7ad?crop=entropy&cs=srgb&fm=jpg&q=90&w=1400",
  chipMacro5: "https://images.pexels.com/photos/28343754/pexels-photo-28343754.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};

// WhatsApp trade enquiry (uses group number). wa.me needs digits only.
export const WHATSAPP = {
  number: "919910444617",
  base: "https://wa.me/919910444617",
};

export const waLink = (productName) =>
  `${WHATSAPP.base}?text=${encodeURIComponent(
    `Hello Meilleur Oudh & Aromas, I'd like a trade enquiry about your ${productName}. Please share grades, pricing and shipping details.`
  )}`;

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BRAND = {
  name: "Meilleur Oudh & Aromas",
  house: "The House of Meilleur",
  tagline: "From Tree to Trade",
  phone: "+91 99104 44617",
  phoneAlt: "+91 97177 21117",
  email: "sales.meilleurplantations@gmail.com",
  address: "A-93, Ashoka Enclave II, Sector 37, Faridabad, Haryana 121003",
  factory: "Plantation & Distillation — Golaghat, Assam",
  website: "www.meilleurplantations.in",
};

export const HERO_STATS = [
  { value: "103", label: "Acres Under Oud Plantation" },
  { value: "27", label: "Oud Distillation Units" },
  { value: "6", label: "GCC Trade Countries" },
  { value: "100+", label: "In-House Developed Scents" },
];

export const COLLECTIONS = [
  {
    slug: "oud-chips",
    name: "Oud Chips",
    kicker: "Agarwood, Graded",
    desc: "Hand-sorted heartwood chips in five grades and three tiers — for incense, diffusers and connoisseurs.",
    image: IMAGES.oudChips,
  },
  {
    slug: "oud-oil",
    name: "Oud Oil",
    kicker: "Distilled Purity",
    desc: "A precious essential oil extracted from Aquilaria heartwood — a symbol of opulence and refinement.",
    image: IMAGES.attarBottlesGold,
  },
  {
    slug: "bakhoor",
    name: "Bakhoor",
    kicker: "Signature Blends",
    desc: "100% organic, certified incense blends built as fragrance pyramids across top, heart and base notes.",
    image: IMAGES.bakhoorBowl,
  },
  {
    slug: "other-products",
    name: "Oud Craft",
    kicker: "Jewellery & Décor",
    desc: "Carved showpieces, oud jewellery and our proprietary inoculum programme for partner farmers.",
    image: IMAGES.carvedArt,
  },
];

export const OUD_CHIP_GRADES = [
  { name: "Muri", character: "Premium, rich aroma — ideal for incense making", tiers: "Triple / Double / Super",
    gallery: ["/gallery/chip-01.jpg", "/gallery/chip-02.jpg", "/gallery/chip-03.jpg", "/gallery/chip-04.jpg"] },
  { name: "Salla", character: "Mid-range, balanced scent — perfect for home fragrance", tiers: "Triple / Double / Super",
    gallery: ["/gallery/chip-05.jpg", "/gallery/chip-06.jpg", "/gallery/chip-07.jpg", "/gallery/chip-08.jpg"] },
  { name: "Jurra", character: "Entry-level, subtle fragrance — suitable for beginners", tiers: "Triple / Double / Super",
    gallery: ["/gallery/chip-09.jpg", "/gallery/chip-10.jpg", "/gallery/chip-01.jpg", "/gallery/chip-05.jpg"] },
  { name: "Kalagashi", character: "Classic wood-chip grade, dense aroma profile", tiers: "Triple / Double / Super",
    gallery: ["/gallery/chip-03.jpg", "/gallery/chip-07.jpg", "/gallery/chip-02.jpg", "/gallery/chip-09.jpg"] },
  { name: "Girmit", character: "Classic wood-chip grade, dense aroma profile", tiers: "Triple / Double / Super",
    gallery: ["/gallery/chip-06.jpg", "/gallery/chip-04.jpg", "/gallery/chip-10.jpg", "/gallery/chip-08.jpg"] },
];

export const CHIP_PHOTOS = Array.from({ length: 10 }, (_, i) => `/gallery/chip-${String(i + 1).padStart(2, "0")}.jpg`);

const chipCaptions = [
  "Premium agarwood oud chips · Meilleur harvest",
  "Hand-sorted heartwood chips · Assam, India",
  "Resin-rich oud chips · graded for incense",
  "Sun-dried agarwood chips · plantation floor",
  "Dense oud chips · Muri grade selection",
  "Freshly graded oud chips · North East India",
  "Carved oud wood pieces · connoisseur grade",
  "Aromatic agarwood chips · trade-ready lots",
  "Raw agarwood heartwood · resin inspection",
  "Fine oud chips · bakhoor & distillation stock",
];

const israelCaptions = [
  "Fragrance evaluation lab · Israel expert visit",
  "Oud analysis session · Israel-based firm",
  "Assessing oud quality · laboratory, Israel",
  "Sensory evaluation · Meilleur as oud expert",
  "Lab collaboration · fragrance development",
  "Distillate testing · pipette analysis",
  "Partnership meeting · boardroom, Israel",
  "Trade discussion · Israel fragrance house",
  "Advisory session · Meilleur oud expertise",
];

const plantCaptions = [
  "Aquilaria plantation · Assam, North East India",
  "Agarwood estate · Meilleur Plantations",
  "Plantation canopy · sustainable forestry",
  "Oud distillation unit · in-house facility",
  "Distillation drums · oud oil extraction",
  "Processing facility · Tripura, India",
  "Nursery & saplings · Aquilaria cultivation",
  "Estate operations · plantation team",
  "On-site processing · Meilleur facility",
  "Plantation landscape · Tripura, India",
];

// Events & recognition — first from uploaded photos, then from the corporate profile PDF.
const eventItems = [
  { src: "/gallery/event-01.jpg", caption: "International delegation · Meilleur Plantations" },
  { src: "/gallery/event-02.jpg", caption: "GCC trade partnership · handshake" },
  { src: "/gallery/event-03.jpg", caption: "Chairman keynote address · industry forum" },
  { src: "/gallery/event-04.jpg", caption: "Award & recognition ceremony" },
  { src: "/gallery/event-05.jpg", caption: "Felicitation · national recognition" },
  { src: "/gallery/event-06.jpg", caption: "Exhibition stand · Meilleur Oud" },
  { src: "/gallery/event-07.jpg", caption: "Trade exhibition · visitor engagement" },
  { src: "/gallery/event-08.jpg", caption: "Conference session · agarwood industry" },
  { src: "/gallery/event-09.jpg", caption: "Business forum · international delegates" },
  { src: "/gallery/event-10.jpg", caption: "Award ceremony · Meilleur Plantations" },
  { src: "/gallery/event-11.jpg", caption: "Exhibition showcase · oud collection" },
  { src: "/gallery/pdf-01.jpg", caption: "Oud Experience Lounge · Delhi NCR" },
  { src: "/gallery/pdf-02.jpg", caption: "Perfume & Oud Exhibition · Sharjah, UAE · 2024" },
  { src: "/gallery/pdf-03.jpg", caption: "ICC India–UAE Business Forum · Ras Al Khaimah, UAE · 2024" },
  { src: "/gallery/pdf-04.jpg", caption: "Delegation visit · BAPS Mandir, Abu Dhabi, UAE" },
  { src: "/gallery/pdf-05.jpg", caption: "Al Marjan Island · Ras Al Khaimah, UAE" },
  { src: "/gallery/pdf-06.jpg", caption: "Tripura Govt. ministerial visit · Tripura, India" },
  { src: "/gallery/pdf-07.jpg", caption: "Our workers · manufacturing unit, Tripura" },
  { src: "/gallery/pdf-08.jpg", caption: "Keynote address · Buyer–Seller Meet · Tripura" },
  { src: "/gallery/pdf-09.jpg", caption: "Intl. Buyer–Seller Meet · Dharmanagar, Tripura" },
  { src: "/gallery/pdf-10.jpg", caption: "Presenting Meilleur Oud · trade delegation" },
  { src: "/gallery/pdf-11.jpg", caption: "Tripura Pavilion · Intl. Trade Fair, New Delhi · 2024" },
  { src: "/gallery/pdf-12.jpg", caption: "Keynote · International Trade Fair · New Delhi" },
  { src: "/gallery/pdf-13.jpg", caption: "Invest India round-table · New Delhi, India" },
];

export const GALLERY_CATEGORIES = [
  {
    id: "chips",
    label: "Oud & Agarwood",
    blurb: "Hand-sorted agarwood chips and resinous heartwood, straight from our own harvest and grading floors.",
    items: CHIP_PHOTOS.map((src, i) => ({ src, caption: chipCaptions[i] })),
  },
  {
    id: "israel",
    label: "The Israel Visit",
    blurb: "Meilleur served as the oud expert for an Israel-based fragrance firm — from the evaluation lab to the boardroom.",
    items: Array.from({ length: 9 }, (_, i) => ({ src: `/gallery/israel-${String(i + 1).padStart(2, "0")}.jpg`, caption: israelCaptions[i] })),
  },
  {
    id: "plantation",
    label: "Plantation & Facility",
    blurb: "Our 103-acre Aquilaria plantations, distillation units and processing facilities across North East India.",
    items: Array.from({ length: 10 }, (_, i) => ({ src: `/gallery/plant-${String(i + 1).padStart(2, "0")}.jpg`, caption: plantCaptions[i] })),
  },
  {
    id: "events",
    label: "Events & Recognition",
    blurb: "On the global stage — exhibitions, trade forums, award ceremonies and international partnerships.",
    items: eventItems,
  },
];

export const OUD_OIL_GRADES = [
  { name: "Grade A", profile: "Our finest expression — the deepest, most concentrated distillation." },
  { name: "Grade B", profile: "A refined, versatile mid-tier distillation." },
  { name: "Boya", profile: "An accessible entry point into pure oud oil." },
];

export const BAKHOOR_BLENDS = [
  { n: "01", name: "Tobacco Oud", notes: "Rose, Musk, Jasmine, Patchouli, Oud, Bergamot, Honey, Amber, Sandal, Cashmeran" },
  { n: "02", name: "Taif Rose", notes: "Geranium, Amber, Sandal, Benzoin, Musk, Vanilla, Oud, Patchouli" },
  { n: "03", name: "Amber Vetiver", notes: "Amber, Sandal, Oud, Musk, Vetiver, Patchouli, Bergamot, Incense, Honey, Saffron" },
  { n: "04", name: "Lavender Blossom", notes: "Lavender, Orange Blossom, Sandal, Amber, Musk, Vanilla, Tonka, Jasmine" },
  { n: "05", name: "Frankincense Cambodi", notes: "Musk, Patchouli, Frankincense, Myrrh, Citrus, Cambodi, Oud, Amber" },
  { n: "06", name: "Seductive Rose", notes: "Rose, Honey, Sandal, Amber, Oud, Vanilla, Musk" },
  { n: "07", name: "Leather Tobacco", notes: "Sandal, Amber, Leather, Vanilla, Musk, Patchouli, Tobacco, Cinnamon, Clove, Honey" },
  { n: "08", name: "Saffron Rose", notes: "Bergamot, Saffron, Sandal, Amber, Oud, Vanilla, Musk, Rose" },
  { n: "09", name: "Frankincense Benzoin", notes: "Frankincense, Honey, Lavender, Benzoin, Amber, Oud, Vanilla, Musk" },
  { n: "10", name: "Saffron Cardamom", notes: "Saffron, Cardamom, Oud, Amber, Musk, Rose" },
  { n: "11", name: "Spiced Leather", notes: "Saffron, Dry Spices, Patchouli, Amber, Musk, Oud, Leather" },
  { n: "12", name: "Ylang Sandalwood", notes: "Jasmine, Ylang-Ylang, Sandalwood, Amber, Musk, Rose, Oud" },
  { n: "13", name: "Jasmine Blossom Oud", notes: "Jasmine, Orange Blossom, Oud, Patchouli, Musk, Sandalwood, Amber, Rose" },
];

export const OTHER_PRODUCTS = [
  { name: "Bakhoor Chips", desc: "Aromatic incense chips, perfect for a relaxing ambiance.", image: IMAGES.incenseBrass,
    gallery: [IMAGES.incenseBrass, IMAGES.bakhoorBowl, IMAGES.incenseStick, IMAGES.ritualSmoke] },
  { name: "Oud Jewellery", desc: "Exquisitely crafted, unique pieces showcasing the beauty of oud.", image: IMAGES.jewellery,
    gallery: [IMAGES.jewellery, IMAGES.carvedArt, IMAGES.oudChips, IMAGES.chipMacro2] },
  { name: "Oud Showpieces", desc: "Decorative carved items adding a touch of luxury and elegance.", image: IMAGES.carvedArt,
    gallery: [IMAGES.carvedArt, IMAGES.jewellery, IMAGES.chipMacro3, IMAGES.chipMacro4] },
];

export const OUD_OIL_GALLERY = [
  IMAGES.attarBottlesGold, IMAGES.perfumeArabic, IMAGES.attarBottle, IMAGES.perfumeGold, IMAGES.perfumeGold2,
];

export const BAKHOOR_GALLERY = [
  IMAGES.bakhoorBowl, IMAGES.incenseStick, IMAGES.incenseBrass, IMAGES.ritualSmoke, IMAGES.whiteSmoke,
];

export const HOUSE_BRANDS = [
  { num: "I", name: "Meilleur Oudh & Aromas", desc: "Plantation-to-product — agarwood/oud chips, oud oil, bakhoor, jewellery and a proprietary inoculum programme." },
  { num: "II", name: "The Scent Lab", desc: "Retail fragrance house — perfumes, attars, incense, puja perfumes and candles, from lounges in Faridabad & Indore." },
  { num: "III", name: "Meilleur Land & Agro Capital Ventures", desc: "Investor-first land vehicle — you own the land, we grow the agarwood, returns structured against realised value." },
  { num: "IV", name: "Ikara Scents", desc: "Artisanal space-scenting technology under Maya Collective — diffusion machines and proprietary fragrance oils." },
];

export const VALUES = [
  { title: "Sustainability", desc: "Responsible forestry practices that contribute to biodiversity and a self-renewing agarwood future." },
  { title: "Community", desc: "Aggregating farmers, skilling a rural workforce, and empowering women and youth across North East India." },
  { title: "Provenance", desc: "Every chip, drop of oil and blend traced to our own 103 acres of Aquilaria in Assam, Tripura and Nagaland." },
  { title: "Craft", desc: "Vertically integrated — from sapling to distillation to finished fragrance, fully in-house." },
];

export const MILESTONES = [
  { year: "2024", title: "International Trade Fair", place: "Inauguration of the Tripura Hall, New Delhi" },
  { year: "2024", title: "Perfume & Oud Exhibition", place: "Sharjah, United Arab Emirates" },
  { year: "2024", title: "ICC India–UAE Business Forum", place: "Al Marjan Island, Ras Al Khaimah — representing India" },
  { year: "2024", title: "India–Bangladesh Business Conference", place: "Dhaka, Bangladesh" },
  { year: "2026", title: "Toward CITES Certification", place: "First agarwood plantation company on its way to CITES export certification" },
];

export const ASSETS = [
  { value: "5,000", label: "Mature Trees", sub: "worth ₹25 crore" },
  { value: "60,000", label: "Saplings", sub: "worth ₹6 crore" },
  { value: "10,000", label: "Inoculated Trees", sub: "worth ₹40 crore" },
  { value: "112", label: "Skilled Labour", sub: "trained in-house" },
];

export const FOUNDER = {
  name: "Dr. Sushil Kumar Verma",
  role: "Founder, Chairman & CEO",
  bio: "A Master's in Computer Science from Jamia Millia Islamia, Dr. Verma brings 30+ years across IT, skill training, agarwood plantation, inoculation and social work. In 2026 he was conferred an Honorary Doctorate (Honoris Causa) by Cedarbrook University, USA, for his contributions to the agarwood industry. He built the international distribution network that carries Meilleur's products into the GCC and parts of Europe.",
  stats: [
    { value: "200", label: "Acres of Agarwood, NE India" },
    { value: "2,000+", label: "Youth Skilled & Placed" },
    { value: "30+", label: "Years of Experience" },
  ],
};


// ---------- Blend Finder ----------
// Each option carries keywords matched against a blend's note list to score a recommendation.
export const BLEND_FINDER_QUESTIONS = [
  {
    id: "family",
    q: "Which scent family calls to you?",
    options: [
      { label: "Rose & Florals", keywords: ["rose", "jasmine", "geranium", "orange blossom", "ylang", "blossom"] },
      { label: "Woody & Earthy", keywords: ["sandal", "sandalwood", "patchouli", "vetiver", "cedar"] },
      { label: "Smoky & Resinous", keywords: ["frankincense", "myrrh", "benzoin", "incense", "amber", "cambodi"] },
      { label: "Sweet & Warm", keywords: ["honey", "vanilla", "tonka", "cashmeran", "amber"] },
      { label: "Leather & Spice", keywords: ["leather", "tobacco", "saffron", "cardamom", "cinnamon", "clove", "spices"] },
    ],
  },
  {
    id: "mood",
    q: "What mood are you setting?",
    options: [
      { label: "Serene & Meditative", keywords: ["lavender", "frankincense", "myrrh", "benzoin", "sandal"] },
      { label: "Romantic & Sensual", keywords: ["rose", "jasmine", "honey", "musk", "vanilla"] },
      { label: "Bold & Commanding", keywords: ["oud", "leather", "tobacco", "patchouli", "saffron"] },
      { label: "Fresh & Uplifting", keywords: ["bergamot", "citrus", "geranium", "orange blossom", "lavender"] },
    ],
  },
  {
    id: "signature",
    q: "Choose your signature note.",
    options: [
      { label: "Saffron", keywords: ["saffron"] },
      { label: "Amber", keywords: ["amber"] },
      { label: "Oud", keywords: ["oud"] },
      { label: "Rose", keywords: ["rose"] },
      { label: "Frankincense", keywords: ["frankincense"] },
      { label: "Tobacco", keywords: ["tobacco"] },
    ],
  },
  {
    id: "intensity",
    q: "How intense should it be?",
    options: [
      { label: "Subtle & Refined", keywords: ["musk", "sandal", "lavender", "bergamot"] },
      { label: "Balanced", keywords: ["amber", "rose", "sandal", "patchouli"] },
      { label: "Deep & Long-lasting", keywords: ["oud", "leather", "tobacco", "saffron", "patchouli"] },
    ],
  },
];
